module.exports = __webpack_public_path__ + "img/13.10e7184e.png";